
import { Component, Ref } from 'vue-property-decorator';

// Utils
import ErrorService from '@/utils/ErrorService';
import { Dictionary } from 'lodash';

// Api
import { deleteUser, getFilteredUsers } from '@/utils/api/Users';

// Components
import VAdministrationMain from '@/components/Administration/VAdministrationMain.vue';
import VAdministrationHeader from '@/components/Administration/VAdministrationHeader.vue';
import VPageTitle from '@/components/Administration/VPageTitle.vue';
import VAdministrationActionbar from '@/components/Administration/VAdministrationActionbar.vue';
import VAdministrationPrimaryTable from '@/components/Administration/VAdministrationPrimaryTable.vue';

import VPoppedAlert from '@/components/VPoppedAlert.vue';
import UserService from '@/utils/UserService';

// Mixins
import VAdministrationPrimaryTableMixin from '@/mixins/VAdministrationPrimaryTableMixin';

// Enums
import ModalEnum from '@/ship/Enums/ModalEnum';
import AdministrationPageNamesEnum from '@/ship/Enums/AdministrationPageNamesEnum';

// Interfaces
import User from '@/ship/Models/User';
import { GetRequestParams } from '@/ship/Requests/RequestParams';

@Component({
    components: {
        VAdministrationMain,
        VAdministrationHeader,
        VPageTitle,
        VAdministrationActionbar,
        VAdministrationPrimaryTable,

        VPoppedAlert,
    },
})
export default class UsersPage extends VAdministrationPrimaryTableMixin {
    @Ref() public poppedAlert!: VPoppedAlert;

    readonly currentPageName = AdministrationPageNamesEnum.Users;
    readonly request = getFilteredUsers;

    declare items: User[];

    get transformedUsers() {
        return this.items.map((user) => {
            const { id, name, email } = user;

            return {
                id,
                name,
                email: email ?? '-',
                roles: UserService.getRoleNames(user),
            };
        });
    }

    public getRequestParams(): GetRequestParams {
        const cityFilter = this.searchCityId ? `cities.id:${this.searchCityId};` : '';
        const searchFilter = this.search
            ? `id,first_name,surname,patronymic,email,roles.display_name:${this.search}`
            : '';

        return {
            filter: 'id;name;email;display_name',
            include: 'roles',
            search: cityFilter + searchFilter,
        };
    }

    public handleDeleteUser(row: Dictionary<string | number>) {
        const { id, name } = row;

        this.$modal.show(ModalEnum.Confirm, {
            title: this.$t('page.administration.sureToDeleteUser', [name]),
            onConfirm: async () => {
                const response = await deleteUser(id as number).catch(ErrorService.handleApiError);

                if (response) {
                    await this.updateItemsThrottled();
                    this.poppedAlert?.show(this.$t('page.administration.userDeleted'));
                }
            },
        });
    }
}
